export default "__VITE_ASSET__BnV$rpwm__"